module.exports = __webpack_public_path__ + "static/media/r203.6a879ab2.jpg";